// extracted by mini-css-extract-plugin
export default {"container":"tMUa8z"};